var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTangible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2357_409435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2323 30.3949V33.7429M10.3043 12.5389H23.6963H10.3043ZM10.3043 12.5389C9.7123 12.5389 9.14458 12.7741 8.726 13.1926C8.30742 13.6112 8.07227 14.1789 8.07227 14.7709V23.6989C8.07227 24.2909 8.30742 24.8586 8.726 25.2772C9.14458 25.6958 9.7123 25.9309 10.3043 25.9309H23.6963C24.2882 25.9309 24.8559 25.6958 25.2745 25.2772C25.6931 24.8586 25.9283 24.2909 25.9283 23.6989V14.7709C25.9283 14.1789 25.6931 13.6112 25.2745 13.1926C24.8559 12.7741 24.2882 12.5389 23.6963 12.5389H10.3043ZM10.3043 12.5389V1.37891H23.6963V12.5389H10.3043ZM14.7683 4.72691V9.19091V4.72691ZM19.2323 4.72691V9.19091V4.72691ZM12.5363 25.9309V30.3949H21.4643V25.9309H12.5363ZM14.7683 30.3949V33.7429V30.3949Z",
    stroke: "#B0C1DB",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_409435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.48,
    height: 33.48,
    fill: "white",
    transform: "translate(0.259766 0.261719)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTangible);
export default __webpack_public_path__ + "static/media/tangible.5f56cdb3.svg";
export { ForwardRef as ReactComponent };